// src/pages/LinkedIn.js
import React from 'react';
import FeaturePageLayout from '../components/FeaturePageLayout';
import { 
    IoLogoLinkedin,
    IoNewspaperOutline, 
    IoBriefcaseOutline, 
    IoAnalyticsOutline, 
    IoPeopleOutline 
} from 'react-icons/io5';
import image1 from '../assets/images/Generate.png';
import image2 from '../assets/images/Schedule2.png';
import image3 from '../assets/images/Messages.png';
import image4 from '../assets/images/Analytics.png';
import heroBg from '../assets/images/linkedin-background.png';

const breadcrumbSchema = { "@context": "https://schema.org", "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://oolook.in/" }, { "@type": "ListItem", "position": 2, "name": "LinkedIn Management", "item": "https://oolook.in/linkedin" }] };
const serviceSchema = { "@context": "https://schema.org", "@type": "Service", "serviceType": "LinkedIn Marketing Software", "provider": { "@type": "Organization", "name": "Oolook" }, "name": "AI LinkedIn Management Tool", "description": "Manage your LinkedIn presence with Oolook. Use AI to write professional articles and posts, schedule content, and analyze your professional impact.", "url": "https://oolook.in/linkedin" };

const pageData = {
  seo: {
    title: "AI LinkedIn Management Tool | Oolook",
    description: "Elevate your professional brand on LinkedIn. Oolook's AI tools help you write thought leadership articles, schedule posts, and analyze your professional network's growth.",
    image: 'https://oolook.in/og/linkedin.png',
    schemas: [breadcrumbSchema, serviceSchema]
  },
  hero: {
    icon: IoLogoLinkedin,
    title: "Build Your Professional Brand on LinkedIn",
    subtitle: "Establish thought leadership, grow your network, and drive business opportunities. Oolook provides the AI tools you need to manage your professional presence with excellence.",
    backgroundImage: heroBg
  },
  featureSection: {
    title: "A Strategic Toolkit for Professional Growth",
    subtitle: "From insightful articles to company page management, our features are tailored for success on LinkedIn.",
    features: [
      { title: "AI Article & Post Writer", description: "Generate professional, insightful content that establishes you as an expert in your field. Perfect for thought leadership.", image: image1 },
      { title: "Schedule for Company & Personal Pages", description: "Plan and schedule content for both your personal profile and your company page from one unified calendar.", image: image2 },
      { title: "Manage Professional Conversations", description: "Keep track of all your LinkedIn comments and messages in our Unified Inbox to nurture your professional network.", image: image3 },
      { title: "Track Your Professional Impact", description: "Analyze the performance of your content, monitor your network growth, and see who's engaging with your profile.", image: image4 }
    ]
  },
  benefitGrid: {
    title: "The ROI of a Strong Professional Presence",
    benefits: [
      { icon: IoNewspaperOutline, title: "Establish Authority", description: "Consistently publish high-quality, insightful content that builds your reputation as a thought leader." },
      { icon: IoBriefcaseOutline, title: "Generate Business Leads", description: "Attract inbound leads and business opportunities by showcasing your expertise and engaging with your network." },
      { icon: IoPeopleOutline, title: "Grow Your Network", description: "Expand your professional connections by staying active and sharing valuable content." },
      { icon: IoAnalyticsOutline, title: "Measure Your Influence", description: "Understand your professional impact with clear analytics on post performance and audience engagement." }
    ]
  },
  // ✅ ADDED MISSING STEP-BY-STEP DATA
  stepByStep: {
    title: "Elevate Your LinkedIn Strategy",
    subtitle: "A professional workflow for building influence and generating opportunities.",
    steps: [
        { title: "1. Connect Your LinkedIn Profile & Pages", description: "Link your personal LinkedIn profile and any Company Pages you manage to Oolook." },
        { title: "2. Draft a Thought Leadership Article", description: "Use the AI writer to generate an insightful article on an industry topic. Review and refine it to match your expertise." },
        { title: "3. Schedule for Peak Professional Hours", description: "Add your new article and related posts to the content calendar for automated publishing during the business week." },
        { title: "4. Engage with Your Network", description: "As professionals comment and message, manage all interactions from the Unified Inbox to build valuable connections." }
    ]
  },
  // ✅ ADDED MISSING TARGET AUDIENCE DATA
  targetAudience: {
    title: "The Go-To Platform for B2B Marketers & Professionals"
  }
};

const LinkedIn = () => {
  return <FeaturePageLayout pageData={pageData} />;
};

export default LinkedIn;